import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import Navbar from "./Navbar";
import Dashboard1 from "./Dashboard1";
import DashboardCharts from "./Dashboard2";
import Dashboard3 from "./Dashboard3";
import Dashboard5 from "./Dashoboard5";

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const news = [
    {
      title: '"Powered by routekart" link',
      content: `Would you like to remove the "Powered by routekart" link in the bottom of the footer? Click here for more info.`,
      link: "#",
    },
    {
      title: "PayPal Commerce. Important update!",
      content: `PayPal deprecates Website Payments Standard (PayPal Express and PayPal Standard). We strongly recommend upgrading to PayPal Commerce to avoid disruption. Use our step-by-step guide to configure PayPal Commerce.`,
      link: "#",
    },
    {
      title: "Recommended hosting for your store",
      content: `Everleap cloud hosting seamlessly scales sites with ease and they move stores for free. Learn more and get a 30 day free trial.`,
      link: "#",
    },
  ];

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-gray-100 text-gray-800">
      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-30 w-64 transform bg-white shadow-lg transition-transform duration-300 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <Navbar />
      </aside>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black opacity-40 z-20 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        {/* Topbar */}
        <header className="flex items-center justify-between bg-white shadow px-4 py-3 lg:px-6">
          <div className="flex items-center gap-2">
            <button
              onClick={toggleSidebar}
              className="text-gray-700 focus:outline-none lg:hidden"
            >
              <Menu size={26} />
            </button>
            <h2 className="text-xl font-semibold">Dashboard</h2>
          </div>
          <div className="flex items-center gap-4 text-gray-700">
            <span>John Smith</span>
            <button className="text-blue-600 hover:underline">Logout</button>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-auto w-full">
          <div className="p-4 sm:p-6 lg:p-8 space-y-8 max-w-full">
            {/* Welcome Card */}
            <div className="bg-white rounded-xl shadow-md p-6 w-full">
              <h3 className="text-2xl font-semibold mb-4">
                Welcome to your store!
              </h3>
              <p className="text-gray-600 mb-6">
                Can’t wait to start accepting orders? Let us show you how to set
                up your store fast and easy. The steps below describe the most
                important settings for the online shop. You will be ready to start
                selling immediately after you go through these steps.
              </p>
            </div>

            {/* Steps Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
              {[
                { title: "Personalize your store", color: "bg-yellow-100 text-yellow-600" },
                { title: "Add your store info", color: "bg-purple-100 text-purple-600" },
                { title: "Set up shipping", color: "bg-orange-100 text-orange-600" },
                { title: "Set up payments", color: "bg-red-100 text-red-600" },
                { title: "Set up taxes", color: "bg-pink-100 text-pink-600" },
                { title: "Create products", color: "bg-teal-100 text-teal-600" },
                { title: "Set up email accounts", color: "bg-indigo-100 text-indigo-600" },
                { title: "Edit services info", color: "bg-green-100 text-green-600" },
                { title: "Powered by link", color: "bg-gray-100 text-gray-600" },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 bg-gray-50 p-4 rounded-lg hover:shadow-md transition-all w-full"
                >
                  <div className={`p-3 rounded-full ${item.color}`}>
                    <span className="font-bold text-lg">{index + 1}</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">{item.title}</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Follow this step to complete your store setup.
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* News Section */}
            <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden w-full">
              <div className="border-b border-gray-300 bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 8c-1.105 0-2 .895-2 2v10a2 2 0 1 0 4 0V10c0-1.105-.895-2-2-2z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 7V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v2M4 10h16"
                  />
                </svg>
                <h2 className="font-semibold text-lg">Router Kart News</h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4 sm:p-6 lg:p-8 w-full">
                {news.map((item, index) => (
                  <div
                    key={index}
                    className="border border-gray-200 rounded-md shadow-sm hover:shadow-md transition-shadow duration-300 bg-white flex flex-col w-full"
                  >
                    <div className="bg-blue-50 text-blue-800 font-medium px-4 py-2 rounded-t-md border-b border-gray-200">
                      {item.title}
                    </div>
                    <div className="p-4 text-gray-700 text-sm leading-relaxed">
                      {item.content.split(" ").map((word, i) => {
                        if (word.toLowerCase().includes("here") || word.toLowerCase().includes("learn"))
                          return (
                            <a
                              key={i}
                              href={item.link}
                              className="text-blue-600 hover:underline"
                            >
                              {word + " "}
                            </a>
                          );
                        return word + " ";
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Dashboard Components */}
            <Dashboard1 />
            <DashboardCharts />
            <Dashboard3 />
            <Dashboard5 />
          </div>
        </main>
      </div>
    </div>
  );
}
